import { ClientServerErrorType, Client } from "types/Client"

export const clientServerErrorMap: Record<ClientServerErrorType, keyof Client> =
  {
    NipExist: "nip",
    CompanyNameExist: "companyName",
    EmailExist: "email"
  }
